export default "__VITE_ASSET__DQ6sj_QB__"